<div
    class="agpr-social-status-switch"
    [attr.aria-label]="'Social.intelligence.themeManagement.themeCard.row.toggleSocialTopicStatus' | localize"
>
    <agpr-social-switch
        [ngClass]="{'agpr-social-status-switch-standby' : isQuotaExceeded}"
        [(ngModel)]="isSwitchOn"
        (ngModelChange)="switchClick()"
        [disabled]="switchDisabled || disabled"
        [onText]="onText"
        [offText]="offText"
        [tooltip]="disabled ? disabledTooltip : 'Social.status.tooltip.' + socialTopicStatus"
        [id]="id"
        [initiallyFocusable]="initiallyFocusable"
        [ariaDescribedBy]="ariaDescribedBy"
    ></agpr-social-switch>
    <div
        class="agpr-social-status-switch-moderatedWarningIndicator"
    >
        <span
            *ngIf="isPartiallyModerated && value != mediaSubscriptionStatusEnum.ACTIVE"
            class="fa-solid fa-circle-exclamation"
            [agprTooltip]="'Social.intelligence.themeManagement.themeCard.moderated' | localize: { agentName: agentName }"
            [initiallyFocusable]="initiallyFocusable"
        ></span>
        <!-- stand_by??? stand_by also has the switched turned on so -->
        <span
            *ngIf="isPartiallyModerated && value === mediaSubscriptionStatusEnum.ACTIVE"
            class="fa-solid fa-circle-exclamation"
            [agprTooltip]="partiallyModeratedTooltip"
            [initiallyFocusable]="initiallyFocusable"
        ></span>
    </div>
</div>
